import { Inject, Injectable } from '@angular/core';
import { CommonsSessionStorageService, downgradeToAJSService, upgradeAJSServiceProvider } from 'ib-web-commons/utils';
import { AJSAncillariesCommonsUtilService, CommonsUtilServiceType } from './upgraded/ib-commons-utils-bridge.service';
import { AJSAncillariesDatalayerHelper, DatalayerHelperType } from './upgraded/ib-datalayer-helper-bridge.service';
import { AJSAncillariesDigitalDataService, DigitalDataServiceType } from './upgraded/ib-digital-data-bridge.service';
import { DatalayerConstants } from '../core/constants/ib-datalayer-contstants';



@Injectable()
export class IbInsuranceAllianzDatalayerUtilsService {

    constructor (
        private localStorageService: CommonsSessionStorageService,
        @Inject(AJSAncillariesCommonsUtilService) private CommonsUtilService: CommonsUtilServiceType,
        @Inject(AJSAncillariesDatalayerHelper) private DatalayerHelper: DatalayerHelperType,
        @Inject(AJSAncillariesDigitalDataService) private DigitalDataService: DigitalDataServiceType
    ) {}

    setInsuranceEcommerceViewItem (ancillaryType: string, product: any): DigitalDataEcommerceModel.Item {
        const confirmationDatalayerInfo: any = this.localStorageService.get('confirmationDatalayerInfo');
        const id = this.CommonsUtilService.getIdItem('all');
        const all = 'all';
        const item: DigitalDataEcommerceModel.Item = {
            item_name: ancillaryType,
            item_id: id,
            price: product.totalPrice,
            item_brand: 'allianz',
            item_category: this.DatalayerHelper.getItemCategory(),
            item_category2: all,
            item_category3: all,
            item_variant: product.productName,
            quantity: confirmationDatalayerInfo?.numeroPax
        };
        return item;
    }

    selectInsuranceEcommerceEventCart (insurance: any, event: string): void {
        const digital_data_ecommerce: DigitalDataEcommerceModel.ViewItemList = { items: [] };
        const id = this.CommonsUtilService.getIdItem('all');
        const item: DigitalDataEcommerceModel.Item = {
            item_name: 'insurance',
            item_id: id,
            price: insurance.totalPrice,
            item_brand: 'allianz',
            item_category: this.DatalayerHelper.getItemCategory(),
            item_category2: 'all',
            item_category3: 'all',
            item_variant: insurance.productName,
            quantity: 1
        };
        digital_data_ecommerce.items.push(item);
        if (digital_data_ecommerce.items.length > 0) {
            this.DigitalDataService.addDigitalDataEcommerceEvent(digital_data_ecommerce, event);
            if (event === DatalayerConstants.EVENTS_ECOMMERCE.ADD_TO_CART && !this.CommonsUtilService.checkIsAddToCart('insurance')) {
                this.DigitalDataService.setAddInfoAddToCart(digital_data_ecommerce);
            } else {
                this.DigitalDataService.setRemoveInfoAddToCart(digital_data_ecommerce);
            }
        }
    }

}

downgradeToAJSService('IbInsuranceAllianzDatalayerUtilsService', IbInsuranceAllianzDatalayerUtilsService, 'ib-web-ancillaries-module');